// Registra il plugin annotation sul singleton Chart.js usato dal componente
// PrimeVue <Chart>. Necessario per le annotazioni eventi nel grafico di analisi
// tracker (FASE 2D). Client-only: Chart.js gira solo lato browser.
import { Chart } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

export default defineNuxtPlugin(() => {
  Chart.register(annotationPlugin);
});
